export const enTextTemplates = {
  PAYMENT_TYPE_LABEL_CREDIT_CARD: "Pay with Card",
  PAYMENT_TYPE_LABEL_BANK_ACCOUNT: "Pay with Bank Account",
  PAYMENT_TYPE_LABEL_PAYPAL: "Pay with Paypal",

  BDS_MESSAGE_ERROR: "Error",
  /* Payment Method Errors */
  STRIPE_LOAD_ERROR: "Stripe was not loaded properly",
  STRIPE_UNKNOWN_ERROR: "Unknown Error",
  STRIPE_INTENT_ERROR: "There was a problem with set payment method",
  NETWORK_ERROR: "Network error",
  TOKEN_ERROR: "The passed token is empty or semantically invalid.",
  STRIPE_REQUIRED_FILED_ERROR: "This field is required",
  STRIPE_VALIDATION_ERROR: "This field is not valid",
  REGISTRATION_RETRY_ERROR:
    "Oops, something went wrong. Try reloading the webpage. Contact support if issue persists.",
  BRAINTREE_SCRIPT_ERROR:
    "There was a problem with loading Paypal SDK. Contact support if the issue persists.",
  BRAINTREE_LOGIN_ERROR:
    "Oops, something went wrong. Please try again. Contact support if the issue persists.",
  CLIENT_TOKEN_ERROR: "The passed client token is expired or invalid.",

  ACH_ROUTING_NUMBER_ERROR: "Routing number is not valid",
  ACH_REQUIRED_FILED_ERROR: "This field is required",
  ACH_CONFIRM_FILED_ERROR: "Account Numbers do not match",
  ACH_ROUTING_NUMBER_LENGTH_ERROR: "Routing number should have 9 characters",
  ACH_ACCOUNT_NUMBER_ERROR: "Account number in not valid",
  ACH_ACCOUNT_NUMBER_LENGTH_ERROR: "Account number should have 4-17 characters",
  ACH_ACCOUNT_NUMBER_DIGITS_ERROR: "Account number should contain digits only",

  ACCOUNT_NUMBER_LABEL: "Account Number",
  ACCOUNT_NUMBER_CONFIRMATION_LABEL: "Confirm Account Number",
  ROUTING_NUMBER_LABEL: "Routing Number",

  ERROR_STATUS_CODE_400: "Request failed with status code 400",
  ERROR_STATUS_CODE_401: "Not authorized: Request failed with status code 401",
  ERROR_STATUS_CODE_403:
    "Missing permissions: Request failed with status code 403",
  ERROR_STATUS_CODE_404: "Not found: Request failed with status code 404",
  ERROR_STATUS_CODE_409: "Request failed with status code 409",
  ERROR_STATUS_CODE_500: "Internal server error",
  ERROR_STATUS_CODE_503: "Request failed with status code 503",
  ERROR_STATUS_CODE_UNDEFINED: "Server error occurred",

  REQUIRED_PROPS_ERROR:
    "Oops, something went wrong. Please try again. Contact support if the issue persists.",

  ZIP_CODE_ERROR: "The Zip Code is incorrect. Please enter valid information.",

  PAYPAL_METHOD_APPROVED: "Secure Method of Payment:  ",
  PAYPAL_TOKENIZATION_ERROR: "PayPal tokenization error.",
  PAYPAL_PAYMENT_PROCESS_REQUIRED:
    "Please fill out the PayPal process payment information.",
};
